var map = {
	"./en/AboutMessages.ts": "95f8",
	"./en/CommonMessages.ts": "00e2",
	"./en/CookiesPolicyMessages.ts": "9033",
	"./en/DonateMessages.ts": "b01e",
	"./en/FormatterMessages.ts": "da41",
	"./en/HomeMessages.ts": "459f",
	"./en/InprogressMessages.ts": "c543",
	"./en/LearnMessages.ts": "bb67",
	"./i18n.ts": "d5f7",
	"./sk/AboutMessages.ts": "9174",
	"./sk/CommonMessages.ts": "6fc7",
	"./sk/CookiesPolicyMessages.ts": "847a",
	"./sk/DonateMessages.ts": "4b2f",
	"./sk/FormatterMessages.ts": "89da",
	"./sk/HomeMessages.ts": "36ff",
	"./sk/InprogressMessages.ts": "a94f",
	"./sk/LearnMessages.ts": "2d0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7b6";